import { isBrowser } from './environment';

function isLinkpulseLoaded() {
    return isBrowser() && window.LP4;
}

export function logPageview(data) {
    if (isLinkpulseLoaded()) {
        window.LP4.logPageview(data);
    }
}

export function setUrl(url) {
    if (isLinkpulseLoaded()) {
        window.LP4.setUrl(url);
    }
}
